import React from "react"

import Layout from "src/components/layout"
import Head from "../../components/Head"
import {graphql, useStaticQuery} from "gatsby"
import {useTranslation} from "react-i18next";

const NotFoundPage = ({ location }) => {
  const data = useStaticQuery(graphql`
    query errorPageClientsAm {
      site {
        siteMetadata {
          countries {
            am {
              hotLine {
                tel
                title
              }
            }
          }
        }
      }
    }
  `)

  const {t} = useTranslation()

  return (
    <>
      <Head
        lang="am"
        title={t('head.404.title')}
        slug="/404/"
      />
      <Layout
        hotLine={data.site.siteMetadata.countries.am.hotLine}
        location={location}
        country="am"
      >
        <h1>NOT FOUND</h1>
        <p>You just hit a route that doesn&#39;t exist... the sadness.</p>
      </Layout>
    </>
  )
}

export default NotFoundPage
